import { render } from "./DeleteInformationPartApplicationsTable.vue?vue&type=template&id=5fec9563"
import script from "./DeleteInformationPartApplicationsTable.vue?vue&type=script&lang=js"
export * from "./DeleteInformationPartApplicationsTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__